export default "__VITE_ASSET__3beb9511__"